//@flow
import React, { useEffect, useMemo } from 'react';
import { useTranslation } from "react-i18next";
import DataGridWrapper from "../../../../components/dataGridWrapper/dataGridWrapper";
import { GridEditInputCell } from '@mui/x-data-grid-premium';
import { PARAMETERS } from "../../locales/namespaces";
import useLoanStatus from "../../hooks/useLoanStatus";
import { withPermissionHOC } from "../../../permission/components/permissionHOC/permissionHOC";
import { Typography } from "@mui/material";
import MainCard from "../../../../theme/mantis/components/mainCard";
import EditableMUIDataGrid from "../../../../components/editableMUIDataGrid/editableMUIDataGrid";
import { CustomPagination } from "../../../../components/dataGridCustom/customPagination";
import EditableMUICellValidation from "../../../../components/editableMUICellValidation/editableMUICellValidation";

const LoanStatus = () => {
	const { t } = useTranslation(PARAMETERS)
	
	useEffect(() => {
		document.title = t('IMS Financial Consulting | Loan Status')
	}, [t])
	
	const {
		loading,
		loanStatus,
		update
	} = useLoanStatus()
	
	const newRowModel = {
		DescriptionEl: '',
		DescriptionEn: '',
		PartnerDescriptionEl: '',
		PartnerDescriptionEn: '',
		PartnerHomeDescriptionEl: '',
		PartnerHomeDescriptionEn: '',
	}
	
	const columns = useMemo(() => [
		{
			field: 'ErpCode',
			headerName: t('Description'),
			minWidth: 160,
			flex: 1,
		},
		{
			field: 'DescriptionEl',
			headerName: t('Description EL'),
			minWidth: 160,
			flex: 1,
			editable: true,
			preProcessEditCellProps: (params) => {
				const inputValue = params.props.value;
				if (inputValue === '') {
					return { ...params.props, error: t('Required') };
				}
				return { ...params.props, error: null }; // No error
			},
			renderEditCell: (params) => {
				return <EditableMUICellValidation {...params}>
					<GridEditInputCell {...params} />
				</EditableMUICellValidation>
			},
		},
		{
			field: 'DescriptionEn',
			headerName: t('Description EN'),
			minWidth: 160,
			flex: 1,
			editable: true,
			preProcessEditCellProps: (params) => {
				const inputValue = params.props.value;
				if (inputValue === '') {
					return { ...params.props, error: t('Required') };
				}
				return { ...params.props, error: null }; // No error
			},
			renderEditCell: (params) => {
				return <EditableMUICellValidation {...params}>
					<GridEditInputCell {...params} />
				</EditableMUICellValidation>
			},
		},
		{
			field: 'PartnerDescriptionEl',
			headerName: t('Partner Description EL'),
			minWidth: 160,
			flex: 1,
			editable: true,
			preProcessEditCellProps: (params) => {
				const inputValue = params.props.value;
				if (inputValue === '') {
					return { ...params.props, error: t('Required') };
				}
				return { ...params.props, error: null }; // No error
			},
			renderEditCell: (params) => {
				return <EditableMUICellValidation {...params}>
					<GridEditInputCell {...params} />
				</EditableMUICellValidation>
			},
		},
		{
			field: 'PartnerDescriptionEn',
			headerName: t('Partner Description EN'),
			minWidth: 160,
			flex: 1,
			editable: true,
			preProcessEditCellProps: (params) => {
				const inputValue = params.props.value;
				if (inputValue === '') {
					return { ...params.props, error: t('Required') };
				}
				return { ...params.props, error: null }; // No error
			},
			renderEditCell: (params) => {
				return <EditableMUICellValidation {...params}>
					<GridEditInputCell {...params} />
				</EditableMUICellValidation>
			},
		}, {
			field: 'PartnerHomeDescriptionEl',
			headerName: t('Home Description EL'),
			minWidth: 160,
			flex: 1,
			editable: true,
			preProcessEditCellProps: (params) => {
				const inputValue = params.props.value;
				if (inputValue === '') {
					return { ...params.props, error: t('Required') };
				}
				return { ...params.props, error: null }; // No error
			},
			renderEditCell: (params) => {
				return <EditableMUICellValidation {...params}>
					<GridEditInputCell {...params} />
				</EditableMUICellValidation>
			},
		},
		{
			field: 'PartnerHomeDescriptionEn',
			headerName: t('Home Description EN'),
			minWidth: 160,
			flex: 1,
			editable: true,
			preProcessEditCellProps: (params) => {
				const inputValue = params.props.value;
				if (inputValue === '') {
					return { ...params.props, error: t('Required') };
				}
				return { ...params.props, error: null }; // No error
			},
			renderEditCell: (params) => {
				return <EditableMUICellValidation {...params}>
					<GridEditInputCell {...params} />
				</EditableMUICellValidation>
			},
		},
	], [t])
	
	return (
		<MainCard
			title={
				<Typography variant="h5" gutterBottom>
					{t('Loan Status')}
				</Typography>
			}
			sx={{ mt: 2 }}
		>
			<DataGridWrapper autoHeight>
				<EditableMUIDataGrid
					sx={{ maxHeight: 700 }}
					loading={loading}
					data={loanStatus}
					columns={columns}
					newRowModel={newRowModel}
					update={update}
					hideDeleteButton={true}
					dataGridProOtherProps={{
						disableColumnMenu: true,
						slots: {
							toolbar: false,
							pagination: CustomPagination,
						}
					}}
				/>
			</DataGridWrapper>
		</MainCard>
	)
}

export default withPermissionHOC(LoanStatus, ['access_parameters']);

